import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { OtherService } from 'src/app/services/other.service';
import { BusyService } from 'src/app/services/busy.service';
import { AccountService } from 'src/app/services/account.service';
import Swal from 'sweetalert2';
import axios from "src/app/services/axios";
import * as moment from 'moment-jalaali';

@Component({

  selector: 'app-partner-financial',

  templateUrl: './partner-financial.component.html',

  styleUrls: ['./partner-financial.component.css', '../partner-trips/partner-trips.component.css']

})

export class PartnerFinancialComponent implements OnInit {

  lst_Trip: any = [];

  lst_Search: any = [];

  iCredit: number = 0;

  iDebit: number = 0;

  mdl_Request: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this._otherService.get_PartnerData().iSystemUser),

    strSession: new FormControl(this._otherService.get_PartnerData().strSession),

  })

  constructor(

    private _router: Router,

    private _route: ActivatedRoute,

    private FormBuilder: FormBuilder,

    private _otherService: OtherService,

    public loaderService: BusyService,

    private _service: AccountService

  ) { }

  ngOnInit(): void {

    this.get_PartnerTrips();

  }

  get_PartnerTrips = async () => {

    this.loaderService.busy();

    let res = JSON.parse((await axios.post(`TaxiLon_Trip_Partner_FinancialReport`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data);

    this.loaderService.idle();

    if (res.bError || res.iResult == 0) return this._service.toastSwal('error', res.strError);

    this.lst_Trip = res;

    this.lst_Search = res;

    this.iCredit = 0;

    this.iDebit = 0;

    this.lst_Trip.forEach((el: any) => {

      this.iCredit += el.iCredit;

      this.iDebit += el.iDebit;

    })

  }

  highlightText(text: string, searchTerm: string) {

    if (!searchTerm) {

      return text;

    }

    const regex = new RegExp(searchTerm, 'gi');

    return text?.replace(regex, (match: string) => {

      return `<mark>${match}</mark>`;

    });

  }

  filter_list(val: any) {

    this.lst_Trip = this.lst_Search.filter((el: any) => {

      return el.strDetail.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Trip = this.lst_Search;

    }

  }

}
